// Utils
import { component } from 'picoapp';

import choozy from 'utils/choozy';
import formatMoney from 'utils/format-money';

export default component((node, ctx) => {
  const { input = [] } = choozy(node);

  const inputs = [].concat(input);

  const { formId, productId } = node.dataset;

  const currentPrices = document.querySelectorAll(`[data-price-current="${productId}"]`);

  const handleChange = (e) => {
    e.stopPropagation();

    node.dispatchEvent(
      new CustomEvent(`${productId}:${formId}:size-change`, { bubbles: true, cancelable: true }),
    );
  };

  const handleSelectSize = (e) => {
    e.stopPropagation();

    const { entries } = e.detail;

    entries.forEach(([name, value]) => {
      inputs.forEach((_input) => {
        if (_input.getAttribute('name') === name && _input.value === value) {
          _input.checked = true;
          _input.dispatchEvent(new Event('change', { bubbles: true, cancelable: true }));
        }
      });
    });
  };

  const handleUpdate = (e) => {
    e.stopPropagation();

    const { currentProductId } = e.detail;
    const { forms } = ctx.getState();
    const formData = forms[currentProductId];

    if (currentProductId !== +productId) return;

    inputs.forEach((_input) => {
      _input.disabled = true;
      _input.checked = false;
    });

    formData.fieldsets.forEach(({ options, name }) => {
      options.forEach((option) => {
        const optionInput = node.querySelector(`input[name="${name}"][value="${option.value}"]`);

        if (optionInput) {
          optionInput.disabled = false;
          optionInput.checked = option.checked;
          optionInput.classList[option.availability === 2 ? 'remove' : 'add']('unavailable');
        }
      });
    });

    currentPrices.forEach((currentPrice) => {
      currentPrice.textContent = formatMoney(formData.selectedVariant.price).removeTrailingZeros();
    });
  };

  node.addEventListener('change', handleChange);

  document.addEventListener(`${productId}:${formId}:select-size`, handleSelectSize);
  document.addEventListener(`${productId}:${formId}:update`, handleUpdate);

  document.addEventListener(
    `${productId}:${formId}:unmount`,
    () => {
      document.removeEventListener(`${productId}:${formId}:select-size`, handleSelectSize);
      document.removeEventListener(`${productId}:${formId}:update`, handleUpdate);
    },
    { once: true },
  );
});
